import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> GDPR </li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>GDPR Compliance</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  The General Data Protection Regulation (GDPR) is the European
                  Union’s landmark data privacy law, designed to protect the
                  personal data of EU citizens and residents. It applies to any
                  organization worldwide that processes, stores, or handles EU
                  personal data, regardless of location. Our GDPR Compliance
                  services help businesses align with GDPR requirements by
                  conducting data protection assessments, implementing technical
                  and organizational safeguards, drafting policies, and ensuring
                  lawful data processing. We empower organizations to build
                  trust with customers while avoiding the heavy fines associated
                  with non-compliance.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Protects Personal Data",
                    desc: "Ensures customer data is handled lawfully and securely.",
                  },
                  {
                    icon: "fa-database",
                    title: "Legal Requirement",
                    desc: "Non-compliance may result in fines up to €20 million or 4% of global turnover.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Global Applicability",
                    desc: "Applies to any business processing EU citizen data, regardless of jurisdiction.",
                  },
                  {
                    icon: "fa-table",
                    title: "Reputation & Trust",
                    desc: "Demonstrates accountability and transparency in data handling.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Competitive Advantage",
                    desc: "GDPR-compliant organizations are preferred by customers and partners.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content" id="ex2-content">
                    {/* Methodology */}
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>We follow a structured framework for GDPR compliance:</p>
                      <ul>
                        <li>
                          <b>Gap & Risk Assessment :-</b> Review current practices against GDPR principles.
                        </li>
                        <li>
                          <b>Data Mapping & Inventory :-</b> Identify what personal data is collected, stored, processed, and shared.
                        </li>
                        <li>
                          <b>Lawful Processing Review :-</b> Verify legal bases for data collection (consent, contract, legitimate interest, etc.).
                        </li>
                        <li>
                          <b>Policy & Documentation Development :-</b> Draft GDPR-compliant privacy policies, cookie notices, and consent forms.
                        </li>
                        <li>
                          <b>Data Subject Rights Enablement :-</b> Implement processes for access, erasure, rectification, portability, and objection requests.
                        </li>
                        <li>
                          <b>Technical Safeguards :-</b> Encryption, pseudonymization, breach detection, and secure data transfers.
                        </li>
                        <li>
                          <b>Third-Party Risk Management :-</b> Review Data Processing Agreements (DPAs) and vendor compliance.
                        </li>
                        <li>
                          <b>Training & Awareness :-</b> Educate staff on GDPR responsibilities.
                        </li>
                        <li>
                          <b>Breach Response Planning :-</b> Ensure compliance with 72-hour breach notification requirements.
                        </li>
                        <li>
                          <b>Ongoing Monitoring :-</b> Maintain compliance as regulations evolve.
                        </li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Avoid costly fines and penalties.</li>
                        <li>Build customer confidence through transparent data handling.</li>
                        <li>Reduce cybersecurity risks with strong technical safeguards.</li>
                        <li>Ensure lawful cross-border data transfers.</li>
                        <li>Improve data governance and accountability across the organization.</li>
                        <li>Gain a competitive edge in EU and global markets.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>With our GDPR Compliance service, you receive:</p>
                      <ul>
                        <li><b>GDPR Gap Assessment Report :-</b> Current compliance status and risk findings.</li>
                        <li><b>Data Mapping & Inventory Documentation :-</b> A record of processing activities (RoPA).</li>
                        <li><b>Privacy Policies & Legal Documentation :-</b> Privacy notice, consent management, and cookie policy.</li>
                        <li><b>Data Protection Impact Assessment (DPIA) :-</b> For high-risk processing activities.</li>
                        <li><b>Data Processing Agreements (DPAs) :-</b> With vendors and partners.</li>
                        <li><b>Employee Training Modules :-</b> GDPR awareness and handling personal data securely.</li>
                        <li><b>Audit-Ready Compliance Package :-</b> Documentation to demonstrate GDPR adherence.</li>
                        <li><b>Continuous Monitoring & Advisory :-</b> Long-term support for regulatory updates.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <ul>
                    <li><b>Global Expertise :-</b> We support businesses operating across EU, UK, and international markets.</li>
                    <li><b>Comprehensive Coverage :-</b> Controls aligned with SOX, PCAOB, GDPR, HIPAA, PCI DSS, ISO. From initial assessment to audit-ready documentation.</li>
                    <li><b>Tailored Solutions :-</b> GDPR strategy customized for your industry, size, and data operations.</li>
                    <li><b>Security + Privacy Integration :-</b> We don’t just document compliance; we secure your data ecosystem.</li>
                    <li><b>Multi-Industry Experience :-</b> E-commerce, SaaS, healthcare, fintech, education, and more.</li>
                    <li><b>Sustainable Compliance :-</b> Providing ongoing guidance to adapt to regulatory changes.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
